module.exports = __webpack_public_path__ + "img/process_03.adfd16cc.png";